export const deviceBrandList = [
  {value: 'apple', label: 'Apple'},
  {value: 'samsung', label: 'Samsung'},
  {value: 'xiaomi', label: 'Xiaomi'},
  {value: 'oppo', label: 'Oppo'},
  {value: 'vivo', label: 'Vivo'},
  {value: 'realme', label: 'Realme'},
  {value: 'honor', label: 'Honor'},
  {value: 'huawei', label: 'Huawei'},
  {value: 'google', label: 'Google'},
  {value: 'motorola', label: 'Motorola'},
  {value: 'lenovo', label: 'Lenovo'},
  {value: 'oneplus', label: 'Oneplus'},
  {value: 'poco', label: 'Poco'},
  {value: 'dell', label: 'Dell'},
  {value: 'asus', label: 'Asus'},
  {value: 'acer', label: 'Acer'},
  {value: 'zte', label: 'ZTE'},
  {value: 'amazon', label: 'Amazon'},
  {value: 'nothing_pnone', label: 'Nothing phone'},
  {value: 'alcatel', label: 'Alcatel'},
  {value: 'lg', label: 'LG'},
  {value: 'sony', label: 'Sony'},
];

export const deviceLanguageListEn = [
  {value: 'ab', label: 'Abkhazian'},
  {value: 'aa', label: 'Afar'},
  {value: 'af', label: 'Afrikaans'},
  {value: 'ak', label: 'Akan'},
  {value: 'sq', label: 'Albanian'},
  {value: 'am', label: 'Amharic'},
  {value: 'ar', label: 'Arabic'},
  {value: 'an', label: 'Aragonese'},
  {value: 'hy', label: 'Armenian'},
  {value: 'as', label: 'Assamese'},
  {value: 'av', label: 'Avaric'},
  {value: 'ae', label: 'Avestan'},
  {value: 'ay', label: 'Aymara'},
  {value: 'az', label: 'Azerbaijani'},
  {value: 'bm', label: 'Bambara'},
  {value: 'ba', label: 'Bashkir'},
  {value: 'eu', label: 'Basque'},
  {value: 'bn', label: 'Bengali (Bangla)'},
  {value: 'dz', label: 'Bhutani'},
  {value: 'bh', label: 'Bihari'},
  {value: 'bi', label: 'Bislama'},
  {value: 'bs', label: 'Bosnian'},
  {value: 'br', label: 'Breton'},
  {value: 'bg', label: 'Bulgarian'},
  {value: 'my', label: 'Burmese'},
  {value: 'be', label: 'Byelorussian (Belarusian)'},
  {value: 'km', label: 'Cambodian'},
  {value: 'ca', label: 'Catalan'},
  {value: 'ch', label: 'Chamorro'},
  {value: 'ce', label: 'Chechen'},
  {value: 'zh', label: 'Chinese'},
  {value: 'zh-Hans', label: 'Chinese (Simplified)'},
  {value: 'zh-Hant', label: 'Chinese (Traditional)'},
  {value: 'cu', label: 'Church Slavic'},
  {value: 'cv', label: 'Chuvash'},
  {value: 'kw', label: 'Cornish'},
  {value: 'co', label: 'Corsican'},
  {value: 'cr', label: 'Cree'},
  {value: 'ny', label: 'Chichewa'},
  {value: 'hr', label: 'Croatian'},
  {value: 'cs', label: 'Czech'},
  {value: 'da', label: 'Danish'},
  {value: 'dv', label: 'Dhivehi'},
  {value: 'nl', label: 'Dutch'},
  {value: 'en', label: 'English'},
  {value: 'eo', label: 'Esperanto'},
  {value: 'et', label: 'Estonian'},
  {value: 'ee', label: 'Ewe'},
  {value: 'fo', label: 'Faeroese'},
  {value: 'fa', label: 'Farsi'},
  {value: 'fj', label: 'Fiji'},
  {value: 'fi', label: 'Finnish'},
  {value: 'fr', label: 'French'},
  {value: 'fy', label: 'Frisian'},
  {value: 'ff', label: 'Fulah'},
  {value: 'lg', label: 'Ganda'},
  {value: 'gl', label: 'Galician'},
  {value: 'gd', label: 'Gaelic (Scottish)'},
  {value: 'gv', label: 'Gaelic (Manx)'},
  {value: 'ka', label: 'Georgian'},
  {value: 'de', label: 'German'},
  {value: 'el', label: 'Greek'},
  {value: 'kl', label: 'Greenlandic'},
  {value: 'gn', label: 'Guarani'},
  {value: 'gu', label: 'Gujarati'},
  {value: 'ht', label: 'Haitian Creole'},
  {value: 'ha', label: 'Hausa'},
  {value: 'he', label: 'Hebrew'},
  {value: 'hz', label: 'Herero'},
  {value: 'iw', label: 'Hebrew (iw)'},
  {value: 'hi', label: 'Hindi'},
  {value: 'ho', label: 'Hiri Motu'},
  {value: 'hu', label: 'Hungarian'},
  {value: 'is', label: 'Icelandic'},
  {value: 'io', label: 'Ido'},
  {value: 'ig', label: 'Igbo'},
  {value: 'id', label: 'Indonesian'},
  {value: 'in', label: 'Indonesian (in)'},
  {value: 'ia', label: 'Interlingua'},
  {value: 'ie', label: 'Interlingue'},
  {value: 'iu', label: 'Inuktitut'},
  {value: 'ik', label: 'Inupiak'},
  {value: 'ga', label: 'Irish'},
  {value: 'it', label: 'Italian'},
  {value: 'ja', label: 'Japanese'},
  {value: 'jv', label: 'Javanese'},
  {value: 'kn', label: 'Kannada'},
  {value: 'kr', label: 'Kanuri'},
  {value: 'ks', label: 'Kashmiri'},
  {value: 'kk', label: 'Kazakh'},
  {value: 'ki', label: 'Kikuyu'},
  {value: 'rw', label: 'Kinyarwanda (Ruanda)'},
  {value: 'ky', label: 'Kirghiz'},
  {value: 'rn', label: 'Kirundi (Rundi)'},
  {value: 'kv', label: 'Komi'},
  {value: 'kg', label: 'Kongo'},
  {value: 'ko', label: 'Korean'},
  {value: 'kj', label: 'Kuanyama'},
  {value: 'ku', label: 'Kurdish'},
  {value: 'lo', label: 'Laothian'},
  {value: 'la', label: 'Latin'},
  {value: 'lv', label: 'Latvian (Lettish)'},
  {value: 'li', label: 'Limburgish ( Limburger)'},
  {value: 'ln', label: 'Lingala'},
  {value: 'lt', label: 'Lithuanian'},
  {value: 'lu', label: 'Luba-Katanga'},
  {value: 'lb', label: 'Luxembourgish'},
  {value: 'mk', label: 'Macedonian'},
  {value: 'mg', label: 'Malagasy'},
  {value: 'ms', label: 'Malay'},
  {value: 'ml', label: 'Malayalam'},
  {value: 'mt', label: 'Maltese'},
  {value: 'mi', label: 'Maori'},
  {value: 'mr', label: 'Marathi'},
  {value: 'mh', label: 'Marshallese'},
  {value: 'mo', label: 'Moldavian'},
  {value: 'mn', label: 'Mongolian'},
  {value: 'na', label: 'Nauru'},
  {value: 'nv', label: 'Navajo'},
  {value: 'ng', label: 'Ndonga'},
  {value: 'ne', label: 'Nepali'},
  {value: 'nd', label: 'North Ndebele'},
  {value: 'se', label: 'Northern Sami'},
  {value: 'no', label: 'Norwegian'},
  {value: 'nb', label: 'Norwegian Bokmål'},
  {value: 'nn', label: 'Norwegian Nynorsk'},
  {value: 'oc', label: 'Occitan'},
  {value: 'oj', label: 'Ojibwa'},
  {value: 'or', label: 'Oriya'},
  {value: 'om', label: 'Oromo (Afaan Oromo)'},
  {value: 'os', label: 'Ossetian'},
  {value: 'pi', label: 'Pali'},
  {value: 'ps', label: 'Pashto (Pushto)'},
  {value: 'pl', label: 'Polish'},
  {value: 'pt', label: 'Portuguese'},
  {value: 'pa', label: 'Punjabi'},
  {value: 'qu', label: 'Quechua'},
  {value: 'rm', label: 'Rhaeto-Romance'},
  {value: 'ro', label: 'Romanian'},
  {value: 'ru', label: 'Russian'},
  {value: 'sm', label: 'Samoan'},
  {value: 'sg', label: 'Sango'},
  {value: 'sa', label: 'Sanskrit'},
  {value: 'sc', label: 'Sardinian'},
  {value: 'sr', label: 'Serbian'},
  {value: 'sh', label: 'Serbo-Croatian'},
  {value: 'st', label: 'Southern Sotho'},
  {value: 'tn', label: 'Setswana'},
  {value: 'sn', label: 'Shona'},
  {value: 'ii', label: 'Sichuan Yi'},
  {value: 'sd', label: 'Sindhi'},
  {value: 'si', label: 'Sinhalese'},
  {value: 'ss', label: 'Swati'},
  {value: 'sk', label: 'Slovak'},
  {value: 'sl', label: 'Slovenian'},
  {value: 'so', label: 'Somali'},
  {value: 'nr', label: 'South Ndebele'},
  {value: 'es', label: 'Spanish'},
  {value: 'su', label: 'Sundanese'},
  {value: 'sw', label: 'Swahili (Kiswahili)'},
  {value: 'sv', label: 'Swedish'},
  {value: 'tl', label: 'Tagalog'},
  {value: 'ty', label: 'Tahitian'},
  {value: 'tg', label: 'Tajik'},
  {value: 'ta', label: 'Tamil'},
  {value: 'tt', label: 'Tatar'},
  {value: 'te', label: 'Telugu'},
  {value: 'th', label: 'Thai'},
  {value: 'bo', label: 'Tibetan'},
  {value: 'ti', label: 'Tigrinya'},
  {value: 'to', label: 'Tonga'},
  {value: 'ts', label: 'Tsonga'},
  {value: 'tr', label: 'Turkish'},
  {value: 'tk', label: 'Turkmen'},
  {value: 'tw', label: 'Twi'},
  {value: 'ug', label: 'Uighur'},
  {value: 'uk', label: 'Ukrainian'},
  {value: 'ur', label: 'Urdu'},
  {value: 'uz', label: 'Uzbek'},
  {value: 've', label: 'Venda'},
  {value: 'vi', label: 'Vietnamese'},
  {value: 'vo', label: 'Volapük'},
  {value: 'wa', label: 'Wallon'},
  {value: 'cy', label: 'Welsh'},
  {value: 'wo', label: 'Wolof'},
  {value: 'xh', label: 'Xhosa'},
  {value: 'yi', label: 'Yiddish'},
  {value: 'ji', label: 'Yiddish (ji)'},
  {value: 'yo', label: 'Yoruba'},
  {value: 'za', label: 'Zhuang'},
  {value: 'zu', label: 'Zulu'},
];

///////////////////////////////////////////////////////////////////

export const browserList = [
  {value: 'Chrome', label: 'Chrome'},
  {value: 'Edge', label: 'Edge'},
  {value: 'Safari', label: 'Safari'},
  {value: 'Mozilla', label: 'Mozilla Firefox'},
  {value: 'Opera', label: 'Opera'},
  {value: 'UCBrowser', label: 'UC Browser'},
  {value: 'Yandex', label: 'Yandex'},
];

///////////////////////////////////////////////////////////////////

export const osList = {
  'Android': {
    all: {
      name: 'Android',
      title: 'Android (All)',
    },
    items: [
      {
        version: '8.0',
        name: 'Android 8.0',
        title: 'Android 8.0.X Oreo',
      },
      {
        version: '8.1',
        name: 'Android 8.1',
        title: 'Android 8.1.X Oreo',
      },
      {
        version: '9.0',
        name: 'Android 9.0',
        title: 'Android 9.0.X Pie',
      },
      {
        version: '10.0',
        name: 'Android 10.0',
        title: 'Android 10.0.X',
      },
      {
        version: '11.0',
        name: 'Android 11.0',
        title: 'Android 11.0.X',
      },
      {
        version: '12.0',
        name: 'Android 12.0',
        title: 'Android 12.0.X',
      },
      {
        version: '13.0',
        name: 'Android 13.0',
        title: 'Android 13.0.X',
      },
      {
        version: '14.0',
        name: 'Android 14.0',
        title: 'Android 14.0.X',
      },
      {
        version: '15.0',
        name: 'Android 15.0',
        title: 'Android 15.0.X',
      },
    ],
  },
  'iOS': {
    all: {
      name: 'iOS',
      title: 'iOS (All)',
    },
    items: [
      {
        version: '10.0',
        name: 'iOS 10.0',
        title: 'iOS 10.0.X',
      },
      {
        version: '10.1',
        name: 'iOS 10.1',
        title: 'iOS 10.1.X',
      },
      {
        version: '10.2',
        name: 'iOS 10.2',
        title: 'iOS 10.2.X',
      },
      {
        version: '10.3',
        name: 'iOS 10.3',
        title: 'iOS 10.3.X',
      },
      {
        version: '11.0',
        name: 'iOS 11.0',
        title: 'iOS 11.0.X',
      },
      {
        version: '11.1',
        name: 'iOS 11.1',
        title: 'iOS 11.1.X',
      },
      {
        version: '11.2',
        name: 'iOS 11.2',
        title: 'iOS 11.2.X',
      },
      {
        version: '11.3',
        name: 'iOS 11.3',
        title: 'iOS 11.3.X',
      },
      {
        version: '11.4',
        name: 'iOS 11.4',
        title: 'iOS 11.4.X',
      },
      {
        version: '12.0',
        name: 'iOS 12.0',
        title: 'iOS 12.0.X',
      },
      {
        version: '12.1',
        name: 'iOS 12.1',
        title: 'iOS 12.1.X',
      },
      {
        version: '12.2',
        name: 'iOS 12.2',
        title: 'iOS 12.2.X',
      },
      {
        version: '12.3',
        name: 'iOS 12.3',
        title: 'iOS 12.3.X',
      },
      {
        version: '12.4',
        name: 'iOS 12.4',
        title: 'iOS 12.4.X',
      },
      {
        version: '12.5',
        name: 'iOS 12.5',
        title: 'iOS 12.5.X',
      },
      {
        version: '13.0',
        name: 'iOS 13.0',
        title: 'iOS 13.0.X',
      },
      {
        version: '13.1',
        name: 'iOS 13.1',
        title: 'iOS 13.1.X',
      },
      {
        version: '13.2',
        name: 'iOS 13.2',
        title: 'iOS 13.2.X',
      },
      {
        version: '13.3',
        name: 'iOS 13.3',
        title: 'iOS 13.3.X',
      },
      {
        version: '13.4',
        name: 'iOS 13.4',
        title: 'iOS 13.4.X',
      },
      {
        version: '13.5',
        name: 'iOS 13.5',
        title: 'iOS 13.5.X',
      },
      {
        version: '13.6',
        name: 'iOS 13.6',
        title: 'iOS 13.6.X',
      },
      {
        version: '13.7',
        name: 'iOS 13.7',
        title: 'iOS 13.7.X',
      },
      {
        version: '14.0',
        name: 'iOS 14.0',
        title: 'iOS 14.0.X',
      },
      {
        version: '14.1',
        name: 'iOS 14.1',
        title: 'iOS 14.1.X',
      },
      {
        version: '14.2',
        name: 'iOS 14.2',
        title: 'iOS 14.2.X',
      },
      {
        version: '14.3',
        name: 'iOS 14.3',
        title: 'iOS 14.3.X',
      },
      {
        version: '14.4',
        name: 'iOS 14.4',
        title: 'iOS 14.4.X',
      },
      {
        version: '14.5',
        name: 'iOS 14.5',
        title: 'iOS 14.5.X',
      },
      {
        version: '14.6',
        name: 'iOS 14.6',
        title: 'iOS 14.6.X',
      },
      {
        version: '14.7',
        name: 'iOS 14.7',
        title: 'iOS 14.7.X',
      },
      {
        version: '14.8',
        name: 'iOS 14.8',
        title: 'iOS 14.8.X',
      },
      {
        version: '15.0',
        name: 'iOS 15.0',
        title: 'iOS 15.0.X',
      },
      {
        version: '15.1',
        name: 'iOS 15.1',
        title: 'iOS 15.1.X',
      },
      {
        version: '15.2',
        name: 'iOS 15.2',
        title: 'iOS 15.2.X',
      },
      {
        version: '15.3',
        name: 'iOS 15.3',
        title: 'iOS 15.3.X',
      },
      {
        version: '15.4',
        name: 'iOS 15.4',
        title: 'iOS 15.4.X',
      },
      {
        version: '15.5',
        name: 'iOS 15.5',
        title: 'iOS 15.5.X',
      },
      {
        version: '15.6',
        name: 'iOS 15.6',
        title: 'iOS 15.6.X',
      },
      {
        version: '15.7',
        name: 'iOS 15.7',
        title: 'iOS 15.7.X',
      },
      {
        version: '15.8',
        name: 'iOS 15.8',
        title: 'iOS 15.8.X',
      },
      {
        version: '16.0',
        name: 'iOS 16.0',
        title: 'iOS 16.0.X',
      },
      {
        version: '16.1',
        name: 'iOS 16.1',
        title: 'iOS 16.1.X',
      },
      {
        version: '16.2',
        name: 'iOS 16.2',
        title: 'iOS 16.2.X',
      },
      {
        version: '16.3',
        name: 'iOS 16.3',
        title: 'iOS 16.3.X',
      },
      {
        version: '16.4',
        name: 'iOS 16.4',
        title: 'iOS 16.4.X',
      },
      {
        version: '16.5',
        name: 'iOS 16.5',
        title: 'iOS 16.5.X',
      },
      {
        version: '16.6',
        name: 'iOS 16.6',
        title: 'iOS 16.6.X',
      },
      {
        version: '16.7',
        name: 'iOS 16.7',
        title: 'iOS 16.7.X',
      },
      {
        version: '17.0',
        name: 'iOS 17.0',
        title: 'iOS 17.0.X',
      },
      {
        version: '17.1',
        name: 'iOS 17.1',
        title: 'iOS 17.1.X',
      },
      {
        version: '17.2',
        name: 'iOS 17.2',
        title: 'iOS 17.2.X',
      },
      {
        version: '17.3',
        name: 'iOS 17.3',
        title: 'iOS 17.3.X',
      },
      {
        version: '17.4',
        name: 'iOS 17.4',
        title: 'iOS 17.4.X',
      },
      {
        version: '17.5',
        name: 'iOS 17.5',
        title: 'iOS 17.5.X',
      },
      {
        version: '17.6',
        name: 'iOS 17.6',
        title: 'iOS 17.6.X',
      },
      {
        version: '17.7',
        name: 'iOS 17.7',
        title: 'iOS 17.7.X',
      },
      {
        version: '18.0',
        name: 'iOS 18.0',
        title: 'iOS 18.0.X',
      },
      {
        version: '18.1',
        name: 'iOS 18.1',
        title: 'iOS 18.1.X',
      },
      {
        version: '18.2',
        name: 'iOS 18.2',
        title: 'iOS 18.2.X',
      },
      {
        version: '18.3',
        name: 'iOS 18.3',
        title: 'iOS 18.3.X',
      },
      {
        version: '18.4',
        name: 'iOS 18.4',
        title: 'iOS 18.4.X',
      },
      {
        version: '18.5',
        name: 'iOS 18.5',
        title: 'iOS 18.5.X',
      },
      {
        version: '18.6',
        name: 'iOS 18.6',
        title: 'iOS 18.6.X',
      },
      {
        version: '18.7',
        name: 'iOS 18.7',
        title: 'iOS 18.7.X',
      },
      {
        version: '26.0',
        name: 'iOS 26.0',
        title: 'iOS 26.0.X',
      },
      {
        version: '26.1',
        name: 'iOS 26.1',
        title: 'iOS 26.1.X',
      },
      {
        version: '26.2',
        name: 'iOS 26.2',
        title: 'iOS 26.2.X',
      },
    ],
  },
  'Microsoft Windows': {
    all: {
      name: 'Windows',
      title: 'Windows (All)',
    },
    items: [
      {
        version: '8.1',
        name: 'Windows 8.1',
        title: 'Windows 8.1',
      },
      {
        version: '10',
        name: 'Windows 10',
        title: 'Windows 10',
      },
      {
        version: '11',
        name: 'Windows 11',
        title: 'Windows 11',
      },
    ]
  },
  'macOS': {
    all: {
      name: 'Mac OS',
      title: 'Mac OS (All)',
    },
    items: [
      {
        version: '10.10',
        name: 'Mac OS 10.10',
        title: 'Mac OS 10.10 Yosemite',
      },
      {
        version: '10.11',
        name: 'Mac OS 10.11',
        title: 'Mac OS 10.11 El Capitan',
      },
      {
        version: '10.12',
        name: 'Mac OS 10.12',
        title: 'Mac OS 10.12 Sierra',
      },
      {
        version: '10.13',
        name: 'Mac OS 10.13',
        title: 'Mac OS 10.13 High Sierra',
      },
      {
        version: '10.14',
        name: 'Mac OS 10.14',
        title: 'Mac OS 10.14 High Sierra',
      },
      {
        version: '10.15',
        name: 'Mac OS 10.15',
        title: 'Mac OS 10.15 High Sierra',
      },
      {
        version: '11.0',
        name: 'Mac OS 11.0',
        title: 'Mac OS 11.0 Big Sur',
      },
      {
        version: '11.1',
        name: 'Mac OS 11.1',
        title: 'Mac OS 11.1 Big Sur',
      },
      {
        version: '11.2',
        name: 'Mac OS 11.2',
        title: 'Mac OS 11.2 Big Sur',
      },
      {
        version: '11.3',
        name: 'Mac OS 11.3',
        title: 'Mac OS 11.3 Big Sur',
      },
      {
        version: '11.4',
        name: 'Mac OS 11.4',
        title: 'Mac OS 11.4 Big Sur',
      },
      {
        version: '11.5',
        name: 'Mac OS 11.5',
        title: 'Mac OS 11.5 Big Sur',
      },
      {
        version: '11.6',
        name: 'Mac OS 11.6',
        title: 'Mac OS 11.6 Big Sur',
      },
      {
        version: '12.0',
        name: 'Mac OS 12.0',
        title: 'Mac OS 12.0 Monterey',
      },
      {
        version: '12.1',
        name: 'Mac OS 12.1',
        title: 'Mac OS 12.1 Monterey',
      },
      {
        version: '12.2',
        name: 'Mac OS 12.2',
        title: 'Mac OS 12.2 Monterey',
      },
      {
        version: '12.3',
        name: 'Mac OS 12.3',
        title: 'Mac OS 12.3 Monterey',
      },
      {
        version: '12.4',
        name: 'Mac OS 12.4',
        title: 'Mac OS 12.4 Monterey',
      },
      {
        version: '12.5',
        name: 'Mac OS 12.5',
        title: 'Mac OS 12.5 Monterey',
      },
      {
        version: '12.6',
        name: 'Mac OS 12.6',
        title: 'Mac OS 12.6 Monterey',
      },
      {
        version: '13.0',
        name: 'Mac OS 13.0',
        title: 'Mac OS 13.0 Ventura',
      },
      {
        version: '13.1',
        name: 'Mac OS 13.1',
        title: 'Mac OS 13.1 Ventura',
      },
      {
        version: '13.2',
        name: 'Mac OS 13.2',
        title: 'Mac OS 13.2 Ventura',
      },
      {
        version: '13.3',
        name: 'Mac OS 13.3',
        title: 'Mac OS 13.3 Ventura',
      },
      {
        version: '13.4',
        name: 'Mac OS 13.4',
        title: 'Mac OS 13.4 Ventura',
      },
      {
        version: '13.5',
        name: 'Mac OS 13.5',
        title: 'Mac OS 13.5 Ventura',
      },
      {
        version: '13.6',
        name: 'Mac OS 13.6',
        title: 'Mac OS 13.6 Ventura',
      },
      {
        version: '14.0',
        name: 'Mac OS 14.0',
        title: 'Mac OS 14.0 Sonoma',
      },
      {
        version: '14.1',
        name: 'Mac OS 14.1',
        title: 'Mac OS 14.1 Sonoma',
      },
      {
        version: '14.2',
        name: 'Mac OS 14.2',
        title: 'Mac OS 14.2 Sonoma',
      },
      {
        version: '14.3',
        name: 'Mac OS 14.3',
        title: 'Mac OS 14.3 Sonoma',
      },
      {
        version: '14.4',
        name: 'Mac OS 14.4',
        title: 'Mac OS 14.4 Sonoma',
      },
      {
        version: '14.5',
        name: 'Mac OS 14.5',
        title: 'Mac OS 14.5 Sonoma',
      },
    ],
  },
  'Linux': {
    all: {
      name: 'Linux',
      title: 'Linux (All)',
    },
    items: [],
  },
};

///////////////////////////////////////////////////////////////////

export const iabCategoriesEn = [
  {value: 'IAB1', name: "IAB1 Arts & Entertainment"},
  {value: 'IAB2', name: "IAB2 Automotive"},
  {value: 'IAB3', name: "IAB3 Business"},
  {value: 'IAB4', name: "IAB4 Careers"},
  {value: 'IAB5', name: "IAB5 Education"},
  {value: 'IAB6', name: "IAB6 Family & Parenting"},
  {value: 'IAB7', name: "IAB7 Health & Fitness"},
  {value: 'IAB8', name: "IAB8 Food & Drink"},
  {value: 'IAB9', name: "IAB9 Hobbies & Interests"},
  {value: 'IAB10', name: "IAB10 Home & Garden"},
  {value: 'IAB11', name: "IAB11 Law, Gov't & Politics"},
  {value: 'IAB12', name: "IAB12 News"},
  {value: 'IAB13', name: "IAB13 Personal Finance"},
  {value: 'IAB14', name: "IAB14 Society"},
  {value: 'IAB15', name: "IAB15 Science"},
  {value: 'IAB16', name: "IAB16 Pets"},
  {value: 'IAB17', name: "IAB17 Sports"},
  {value: 'IAB18', name: "IAB18 Style & Fashion"},
  {value: 'IAB19', name: "IAB19 Technology & Computing"},
  {value: 'IAB20', name: "IAB20 Travel"},
  {value: 'IAB21', name: "IAB21 Real Estate"},
  {value: 'IAB22', name: "IAB22 Shopping"},
  {value: 'IAB23', name: "IAB23 Religion & Spirituality"},
];

export const iabCategoriesRu = [
  {value: 'IAB1', name: "IAB1 Искусство и развлечения"},
  {value: 'IAB2', name: "IAB2 Автомобили"},
  {value: 'IAB3', name: "IAB3 Бизнес"},
  {value: 'IAB4', name: "IAB4 Карьера"},
  {value: 'IAB5', name: "IAB5 Образование"},
  {value: 'IAB6', name: "IAB6 Семья и родители"},
  {value: 'IAB7', name: "IAB7 Здоровье и фитнес"},
  {value: 'IAB8', name: "IAB8 Еда и напитки"},
  {value: 'IAB9', name: "IAB9 Хобби и интересы"},
  {value: 'IAB10', name: "IAB10 Дом и Сад"},
  {value: 'IAB11', name: "IAB11 Право, правительство и политика"},
  {value: 'IAB12', name: "IAB12 Новости"},
  {value: 'IAB13', name: "IAB13 Личные финансы"},
  {value: 'IAB14', name: "IAB14 Общество"},
  {value: 'IAB15', name: "IAB15 Наука"},
  {value: 'IAB16', name: "IAB16 Домашние животные"},
  {value: 'IAB17', name: "IAB17 Спорт"},
  {value: 'IAB18', name: "IAB18 Стиль и мода"},
  {value: 'IAB19', name: "IAB19 Технологии и компьютеры"},
  {value: 'IAB20', name: "IAB20 Путешествия"},
  {value: 'IAB21', name: "IAB21 Недвижимость"},
  {value: 'IAB22', name: "IAB22 Покупки"},
  {value: 'IAB23', name: "IAB23 Религия и духовность"},
];

export const iabCategoriesList = [
  {
    "id": "IAB1-1",
    "name": "Books & Literature",
    "fullName": "IAB1-1 Books & Literature"
  },
  {
    "id": "IAB1-2",
    "name": "Celebrity Fan/Gossip",
    "fullName": "IAB1-2 Celebrity Fan/Gossip"
  },
  {
    "id": "IAB1-3",
    "name": "Fine Art",
    "fullName": "IAB1-3 Fine Art"
  },
  {
    "id": "IAB1-4",
    "name": "Humor",
    "fullName": "IAB1-4 Humor"
  },
  {
    "id": "IAB1-5",
    "name": "Movies",
    "fullName": "IAB1-5 Movies"
  },
  {
    "id": "IAB1-6",
    "name": "Music",
    "fullName": "IAB1-6 Music"
  },
  {
    "id": "IAB1-7",
    "name": "Television",
    "fullName": "IAB1-7 Television"
  },
  {
    "id": "IAB2-1",
    "name": "Auto Parts",
    "fullName": "IAB2-1 Auto Parts"
  },
  {
    "id": "IAB2-2",
    "name": "Auto Repair",
    "fullName": "IAB2-2 Auto Repair"
  },
  {
    "id": "IAB2-3",
    "name": "Buying/Selling Cars",
    "fullName": "IAB2-3 Buying/Selling Cars"
  },
  {
    "id": "IAB2-4",
    "name": "Car Culture",
    "fullName": "IAB2-4 Car Culture"
  },
  {
    "id": "IAB2-5",
    "name": "Certified Pre-Owned",
    "fullName": "IAB2-5 Certified Pre-Owned"
  },
  {
    "id": "IAB2-6",
    "name": "Convertible",
    "fullName": "IAB2-6 Convertible"
  },
  {
    "id": "IAB2-7",
    "name": "Coupe",
    "fullName": "IAB2-7 Coupe"
  },
  {
    "id": "IAB2-8",
    "name": "Crossover",
    "fullName": "IAB2-8 Crossover"
  },
  {
    "id": "IAB2-9",
    "name": "Diese",
    "fullName": "IAB2-9 Diese"
  },
  {
    "id": "IAB2-10",
    "name": "Electric Vehicle",
    "fullName": "IAB2-10 Electric Vehicle"
  },
  {
    "id": "IAB2-11",
    "name": "Hatchback",
    "fullName": "IAB2-11 Hatchback"
  },
  {
    "id": "IAB2-12",
    "name": "Hybrid",
    "fullName": "IAB2-12 Hybrid"
  },
  {
    "id": "IAB2-13",
    "name": "Luxury",
    "fullName": "IAB2-13 Luxury"
  },
  {
    "id": "IAB2-14",
    "name": "MiniVan",
    "fullName": "IAB2-14 MiniVan"
  },
  {
    "id": "IAB2-15",
    "name": "Mororcycles",
    "fullName": "IAB2-15 Mororcycles"
  },
  {
    "id": "IAB2-16",
    "name": "Off-Road Vehicles",
    "fullName": "IAB2-16 Off-Road Vehicles"
  },
  {
    "id": "IAB2-17",
    "name": "Performance Vehicles",
    "fullName": "IAB2-17 Performance Vehicles"
  },
  {
    "id": "IAB2-18",
    "name": "Pickup",
    "fullName": "IAB2-18 Pickup"
  },
  {
    "id": "IAB2-19",
    "name": "Road-Side Assistance",
    "fullName": "IAB2-19 Road-Side Assistance"
  },
  {
    "id": "IAB2-20",
    "name": "Sedan",
    "fullName": "IAB2-20 Sedan"
  },
  {
    "id": "IAB2-21",
    "name": "Trucks & Accessories",
    "fullName": "IAB2-21 Trucks & Accessories"
  },
  {
    "id": "IAB2-22",
    "name": "Vintage Cars",
    "fullName": "IAB2-22 Vintage Cars"
  },
  {
    "id": "IAB2-23",
    "name": "Wagon",
    "fullName": "IAB2-23 Wagon"
  },
  {
    "id": "IAB3-1",
    "name": "Advertising",
    "fullName": "IAB3-1 Advertising"
  },
  {
    "id": "IAB3-2",
    "name": "Agriculture",
    "fullName": "IAB3-2 Agriculture"
  },
  {
    "id": "IAB3-3",
    "name": "Biotech/Biomedical",
    "fullName": "IAB3-3 Biotech/Biomedical"
  },
  {
    "id": "IAB3-4",
    "name": "Business Software",
    "fullName": "IAB3-4 Business Software"
  },
  {
    "id": "IAB3-5",
    "name": "Construction",
    "fullName": "IAB3-5 Construction"
  },
  {
    "id": "IAB3-6",
    "name": "Forestry",
    "fullName": "IAB3-6 Forestry"
  },
  {
    "id": "IAB3-7",
    "name": "Government",
    "fullName": "IAB3-7 Government"
  },
  {
    "id": "IAB3-8",
    "name": "Green Solutions",
    "fullName": "IAB3-8 Green Solutions"
  },
  {
    "id": "IAB3-9",
    "name": "Human Resources",
    "fullName": "IAB3-9 Human Resources"
  },
  {
    "id": "IAB3-10",
    "name": "Logistics",
    "fullName": "IAB3-10 Logistics"
  },
  {
    "id": "IAB3-11",
    "name": "Marketing",
    "fullName": "IAB3-11 Marketing"
  },
  {
    "id": "IAB3-12",
    "name": "Metals",
    "fullName": "IAB3-12 Metals"
  },
  {
    "id": "IAB4-1",
    "name": "Career Planning",
    "fullName": "IAB4-1 Career Planning"
  },
  {
    "id": "IAB4-2",
    "name": "College",
    "fullName": "IAB4-2 College"
  },
  {
    "id": "IAB4-3",
    "name": "Financial Aid",
    "fullName": "IAB4-3 Financial Aid"
  },
  {
    "id": "IAB4-4",
    "name": "Job Fairs",
    "fullName": "IAB4-4 Job Fairs"
  },
  {
    "id": "IAB4-5",
    "name": "Job Search",
    "fullName": "IAB4-5 Job Search"
  },
  {
    "id": "IAB4-6",
    "name": "Resume Writing/Advice",
    "fullName": "IAB4-6 Resume Writing/Advice"
  },
  {
    "id": "IAB4-7",
    "name": "Nursing",
    "fullName": "IAB4-7 Nursing"
  },
  {
    "id": "IAB4-8",
    "name": "Scholarships",
    "fullName": "IAB4-8 Scholarships"
  },
  {
    "id": "IAB4-9",
    "name": "Telecommuting",
    "fullName": "IAB4-9 Telecommuting"
  },
  {
    "id": "IAB4-10",
    "name": "U.S. Military",
    "fullName": "IAB4-10 U.S. Military"
  },
  {
    "id": "IAB4-11",
    "name": "Career Advice",
    "fullName": "IAB4-11 Career Advice"
  },
  {
    "id": "IAB5-1",
    "name": "7-12 Education",
    "fullName": "IAB5-1 7-12 Education"
  },
  {
    "id": "IAB5-2",
    "name": "Adult Education",
    "fullName": "IAB5-2 Adult Education"
  },
  {
    "id": "IAB5-3",
    "name": "Art History",
    "fullName": "IAB5-3 Art History"
  },
  {
    "id": "IAB5-4",
    "name": "Colledge Administration",
    "fullName": "IAB5-4 Colledge Administration"
  },
  {
    "id": "IAB5-5",
    "name": "College Life",
    "fullName": "IAB5-5 College Life"
  },
  {
    "id": "IAB5-6",
    "name": "Distance Learning",
    "fullName": "IAB5-6 Distance Learning"
  },
  {
    "id": "IAB5-7",
    "name": "English as a 2nd Language",
    "fullName": "IAB5-7 English as a 2nd Language"
  },
  {
    "id": "IAB5-8",
    "name": "Language Learning",
    "fullName": "IAB5-8 Language Learning"
  },
  {
    "id": "IAB5-9",
    "name": "Graduate School",
    "fullName": "IAB5-9 Graduate School"
  },
  {
    "id": "IAB5-10",
    "name": "Homeschooling",
    "fullName": "IAB5-10 Homeschooling"
  },
  {
    "id": "IAB5-11",
    "name": "Homework/Study Tips",
    "fullName": "IAB5-11 Homework/Study Tips"
  },
  {
    "id": "IAB5-12",
    "name": "K-6 Educators",
    "fullName": "IAB5-12 K-6 Educators"
  },
  {
    "id": "IAB5-13",
    "name": "Private School",
    "fullName": "IAB5-13 Private School"
  },
  {
    "id": "IAB5-14",
    "name": "Special Education",
    "fullName": "IAB5-14 Special Education"
  },
  {
    "id": "IAB5-15",
    "name": "Studying Business",
    "fullName": "IAB5-15 Studying Business"
  },
  {
    "id": "IAB6-1",
    "name": "Adoption",
    "fullName": "IAB6-1 Adoption"
  },
  {
    "id": "IAB6-2",
    "name": "Babies & Toddlers",
    "fullName": "IAB6-2 Babies & Toddlers"
  },
  {
    "id": "IAB6-3",
    "name": "Daycare/Pre School",
    "fullName": "IAB6-3 Daycare/Pre School"
  },
  {
    "id": "IAB6-4",
    "name": "Family Internet",
    "fullName": "IAB6-4 Family Internet"
  },
  {
    "id": "IAB6-5",
    "name": "Parenting - K-6 Kids",
    "fullName": "IAB6-5 Parenting - K-6 Kids"
  },
  {
    "id": "IAB6-6",
    "name": "Parenting teens",
    "fullName": "IAB6-6 Parenting teens"
  },
  {
    "id": "IAB6-7",
    "name": "Pregnancy",
    "fullName": "IAB6-7 Pregnancy"
  },
  {
    "id": "IAB6-8",
    "name": "Special Needs Kids",
    "fullName": "IAB6-8 Special Needs Kids"
  },
  {
    "id": "IAB6-9",
    "name": "Eldercare",
    "fullName": "IAB6-9 Eldercare"
  },
  {
    "id": "IAB7-1",
    "name": "Exercise",
    "fullName": "IAB7-1 Exercise"
  },
  {
    "id": "IAB7-2",
    "name": "A.D.D.",
    "fullName": "IAB7-2 A.D.D."
  },
  {
    "id": "IAB7-3",
    "name": "AIDS/HIV",
    "fullName": "IAB7-3 AIDS/HIV"
  },
  {
    "id": "IAB7-4",
    "name": "Allergies",
    "fullName": "IAB7-4 Allergies"
  },
  {
    "id": "IAB7-5",
    "name": "Alternative Medicine",
    "fullName": "IAB7-5 Alternative Medicine"
  },
  {
    "id": "IAB7-6",
    "name": "Arthritis",
    "fullName": "IAB7-6 Arthritis"
  },
  {
    "id": "IAB7-7",
    "name": "Asthma",
    "fullName": "IAB7-7 Asthma"
  },
  {
    "id": "IAB7-8",
    "name": "Autism/PDD",
    "fullName": "IAB7-8 Autism/PDD"
  },
  {
    "id": "IAB7-9",
    "name": "Bipolar Disorder",
    "fullName": "IAB7-9 Bipolar Disorder"
  },
  {
    "id": "IAB7-10",
    "name": "Brain Tumor",
    "fullName": "IAB7-10 Brain Tumor"
  },
  {
    "id": "IAB7-11",
    "name": "Cancer",
    "fullName": "IAB7-11 Cancer"
  },
  {
    "id": "IAB7-12",
    "name": "Cholesterol",
    "fullName": "IAB7-12 Cholesterol"
  },
  {
    "id": "IAB7-13",
    "name": "Chronic Fatigue Syndrome",
    "fullName": "IAB7-13 Chronic Fatigue Syndrome"
  },
  {
    "id": "IAB7-14",
    "name": "Chronic Pain",
    "fullName": "IAB7-14 Chronic Pain"
  },
  {
    "id": "IAB7-15",
    "name": "Cold & Flu",
    "fullName": "IAB7-15 Cold & Flu"
  },
  {
    "id": "IAB7-16",
    "name": "Deafness",
    "fullName": "IAB7-16 Deafness"
  },
  {
    "id": "IAB7-17",
    "name": "Dental Care",
    "fullName": "IAB7-17 Dental Care"
  },
  {
    "id": "IAB7-18",
    "name": "Depression",
    "fullName": "IAB7-18 Depression"
  },
  {
    "id": "IAB7-19",
    "name": "Dermatology",
    "fullName": "IAB7-19 Dermatology"
  },
  {
    "id": "IAB7-20",
    "name": "Diabetes",
    "fullName": "IAB7-20 Diabetes"
  },
  {
    "id": "IAB7-21",
    "name": "Epilepsy",
    "fullName": "IAB7-21 Epilepsy"
  },
  {
    "id": "IAB7-22",
    "name": "GERD/Acid Reflux",
    "fullName": "IAB7-22 GERD/Acid Reflux"
  },
  {
    "id": "IAB7-23",
    "name": "Headaches/Migraines",
    "fullName": "IAB7-23 Headaches/Migraines"
  },
  {
    "id": "IAB7-24",
    "name": "Heart Disease",
    "fullName": "IAB7-24 Heart Disease"
  },
  {
    "id": "IAB7-25",
    "name": "Herbs for Health",
    "fullName": "IAB7-25 Herbs for Health"
  },
  {
    "id": "IAB7-26",
    "name": "Holistic Healing",
    "fullName": "IAB7-26 Holistic Healing"
  },
  {
    "id": "IAB7-27",
    "name": "IBS/Crohn's Disease",
    "fullName": "IAB7-27 IBS/Crohn's Disease"
  },
  {
    "id": "IAB7-28",
    "name": "Incest/Abuse Support",
    "fullName": "IAB7-28 Incest/Abuse Support"
  },
  {
    "id": "IAB7-29",
    "name": "Incontinence",
    "fullName": "IAB7-29 Incontinence"
  },
  {
    "id": "IAB7-30",
    "name": "Infertility",
    "fullName": "IAB7-30 Infertility"
  },
  {
    "id": "IAB7-31",
    "name": "I Men's Health",
    "fullName": "IIAB7-31 Men's Health"
  },
  {
    "id": "IAB7-32",
    "name": "Nutrition",
    "fullName": "IAB7-32 Nutrition"
  },
  {
    "id": "IAB7-33",
    "name": "Orthopedics",
    "fullName": "IAB7-33 Orthopedics"
  },
  {
    "id": "IAB7-34",
    "name": "Panic/Anxiety Disorders",
    "fullName": "IAB7-34 Panic/Anxiety Disorders"
  },
  {
    "id": "IAB7-35",
    "name": "Pediatrics",
    "fullName": "IAB7-35 Pediatrics"
  },
  {
    "id": "IAB7-36",
    "name": "Physical Therapy",
    "fullName": "IAB7-36 Physical Therapy"
  },
  {
    "id": "IAB7-37",
    "name": "Psychology/Psychiatry",
    "fullName": "IAB7-37 Psychology/Psychiatry"
  },
  {
    "id": "IAB7-38",
    "name": "Senor Health",
    "fullName": "IAB7-38 Senor Health"
  },
  {
    "id": "IAB7-39",
    "name": "Sexuality",
    "fullName": "IAB7-39 Sexuality"
  },
  {
    "id": "IAB7-40",
    "name": "Sleep Disorders",
    "fullName": "IAB7-40 Sleep Disorders"
  },
  {
    "id": "IAB7-41",
    "name": "Smoking Cessation",
    "fullName": "IAB7-41 Smoking Cessation"
  },
  {
    "id": "IAB7-42",
    "name": "Substance Abuse",
    "fullName": "IAB7-42 Substance Abuse"
  },
  {
    "id": "IAB7-43",
    "name": "Thyroid Disease",
    "fullName": "IAB7-43 Thyroid Disease"
  },
  {
    "id": "IAB7-44",
    "name": "Weight Loss",
    "fullName": "IAB7-44 Weight Loss"
  },
  {
    "id": "IAB7-45",
    "name": "Women's Health",
    "fullName": "IAB7-45 Women's Health"
  },
  {
    "id": "IAB8-1",
    "name": "American Cuisine",
    "fullName": "IAB8-1 American Cuisine"
  },
  {
    "id": "IAB8-2",
    "name": "Barbecues & Grilling",
    "fullName": "IAB8-2 Barbecues & Grilling"
  },
  {
    "id": "IAB8-3",
    "name": "Cajun/Creole",
    "fullName": "IAB8-3 Cajun/Creole"
  },
  {
    "id": "IAB8-4",
    "name": "Chinese Cuisine",
    "fullName": "IAB8-4 Chinese Cuisine"
  },
  {
    "id": "IAB8-5",
    "name": "Cocktails/Beer",
    "fullName": "IAB8-5 Cocktails/Beer"
  },
  {
    "id": "IAB8-6",
    "name": "Coffee/Tea",
    "fullName": "IAB8-6 Coffee/Tea"
  },
  {
    "id": "IAB8-7",
    "name": "Cuisine-Specific",
    "fullName": "IAB8-7 Cuisine-Specific"
  },
  {
    "id": "IAB8-8",
    "name": "Desserts & Baking",
    "fullName": "IAB8-8 Desserts & Baking"
  },
  {
    "id": "IAB8-9",
    "name": "Dining Out",
    "fullName": "IAB8-9 Dining Out"
  },
  {
    "id": "IAB8-10",
    "name": "Food Allergies",
    "fullName": "IAB8-10 Food Allergies"
  },
  {
    "id": "IAB8-11",
    "name": "French Cuisine",
    "fullName": "IAB8-11 French Cuisine"
  },
  {
    "id": "IAB8-12",
    "name": "Health/Lowfat Cooking",
    "fullName": "IAB8-12 Health/Lowfat Cooking"
  },
  {
    "id": "IAB8-13",
    "name": "Italian Cuisine",
    "fullName": "IAB8-13 Italian Cuisine"
  },
  {
    "id": "IAB8-14",
    "name": "Japanese Cuisine",
    "fullName": "IAB8-14 Japanese Cuisine"
  },
  {
    "id": "IAB8-15",
    "name": "Mexican Cuisine",
    "fullName": "IAB8-15 Mexican Cuisine"
  },
  {
    "id": "IAB8-16",
    "name": "Vegan",
    "fullName": "IAB8-16 Vegan"
  },
  {
    "id": "IAB8-17",
    "name": "Vegetarian",
    "fullName": "IAB8-17 Vegetarian"
  },
  {
    "id": "IAB8-18",
    "name": "Wine",
    "fullName": "IAB8-18 Wine"
  },
  {
    "id": "IAB9-1",
    "name": "Art/Technology",
    "fullName": "IAB9-1 Art/Technology"
  },
  {
    "id": "IAB9-2",
    "name": "Arts & Crafts",
    "fullName": "IAB9-2 Arts & Crafts"
  },
  {
    "id": "IAB9-3",
    "name": "Beadwork",
    "fullName": "IAB9-3 Beadwork"
  },
  {
    "id": "IAB9-4",
    "name": "Birdwatching",
    "fullName": "IAB9-4 Birdwatching"
  },
  {
    "id": "IAB9-5",
    "name": "Board Games/Puzzles",
    "fullName": "IAB9-5 Board Games/Puzzles"
  },
  {
    "id": "IAB9-6",
    "name": "Candle & Soap Making",
    "fullName": "IAB9-6 Candle & Soap Making"
  },
  {
    "id": "IAB9-7",
    "name": "Card Games",
    "fullName": "IAB9-7 Card Games"
  },
  {
    "id": "IAB9-8",
    "name": "Chess",
    "fullName": "IAB9-8 Chess"
  },
  {
    "id": "IAB9-9",
    "name": "Cigars",
    "fullName": "IAB9-9 Cigars"
  },
  {
    "id": "IAB9-10",
    "name": "Collecting",
    "fullName": "IAB9-10 Collecting"
  },
  {
    "id": "IAB9-11",
    "name": "Comic Books",
    "fullName": "IAB9-11 Comic Books"
  },
  {
    "id": "IAB9-12",
    "name": "Drawing/Sketching",
    "fullName": "IAB9-12 Drawing/Sketching"
  },
  {
    "id": "IAB9-13",
    "name": "Freelance Writing",
    "fullName": "IAB9-13 Freelance Writing"
  },
  {
    "id": "IAB9-14",
    "name": "Genealogy",
    "fullName": "IAB9-14 Genealogy"
  },
  {
    "id": "IAB9-15",
    "name": "Getting Published",
    "fullName": "IAB9-15 Getting Published"
  },
  {
    "id": "IAB9-16",
    "name": "Guitar",
    "fullName": "IAB9-16 Guitar"
  },
  {
    "id": "IAB9-17",
    "name": "Home Recording",
    "fullName": "IAB9-17 Home Recording"
  },
  {
    "id": "IAB9-18",
    "name": "Investors & Patents",
    "fullName": "IAB9-18 Investors & Patents"
  },
  {
    "id": "IAB9-19",
    "name": "Jewelry Making",
    "fullName": "IAB9-19 Jewelry Making"
  },
  {
    "id": "IAB9-20",
    "name": "Magic & Illusion",
    "fullName": "IAB9-20 Magic & Illusion"
  },
  {
    "id": "IAB9-21",
    "name": "Needlework",
    "fullName": "IAB9-21 Needlework"
  },
  {
    "id": "IAB9-22",
    "name": "Painting",
    "fullName": "IAB9-22 Painting"
  },
  {
    "id": "IAB9-23",
    "name": "Photography",
    "fullName": "IAB9-23 Photography"
  },
  {
    "id": "IAB9-24",
    "name": "Radio",
    "fullName": "IAB9-24 Radio"
  },
  {
    "id": "IAB9-25",
    "name": "Roleplaying Games",
    "fullName": "IAB9-25 Roleplaying Games"
  },
  {
    "id": "IAB9-26",
    "name": "Sci-Fi & Fantasy",
    "fullName": "IAB9-26 Sci-Fi & Fantasy"
  },
  {
    "id": "IAB9-27",
    "name": "Scrapbooking",
    "fullName": "IAB9-27 Scrapbooking"
  },
  {
    "id": "IAB9-28",
    "name": "Screenwriting",
    "fullName": "IAB9-28 Screenwriting"
  },
  {
    "id": "IAB9-29",
    "name": "Stamps & Coins",
    "fullName": "IAB9-29 Stamps & Coins"
  },
  {
    "id": "IAB9-30",
    "name": "Video & Computer Games",
    "fullName": "IAB9-30 Video & Computer Games"
  },
  {
    "id": "IAB9-31",
    "name": "Woodworking",
    "fullName": "IAB9-31 Woodworking"
  },
  {
    "id": "IAB10-1",
    "name": "Appliances",
    "fullName": "IAB10-1 Appliances"
  },
  {
    "id": "IAB10-2",
    "name": "Entertaining",
    "fullName": "IAB10-2 Entertaining"
  },
  {
    "id": "IAB10-3",
    "name": "Environmental Safety",
    "fullName": "IAB10-3 Environmental Safety"
  },
  {
    "id": "IAB10-4",
    "name": "Gardening",
    "fullName": "IAB10-4 Gardening"
  },
  {
    "id": "IAB10-5",
    "name": "IAB10-4 Gardening",
    "fullName": "IAB10-4 Gardening"
  },
  {
    "id": "IAB10-6",
    "name": "Home Theater",
    "fullName": "IAB10-6 Home Theater"
  },
  {
    "id": "IAB10-7",
    "name": "Interior Decorating",
    "fullName": "IAB10-7 Interior Decorating"
  },
  {
    "id": "IAB10-8",
    "name": "Landscaping",
    "fullName": "IAB10-8 Landscaping"
  },
  {
    "id": "IAB10-9",
    "name": "Remodeling & Construction",
    "fullName": "IAB10-9 Remodeling & Construction"
  },
  {
    "id": "IAB11-1",
    "name": "Immigration",
    "fullName": "IAB11-1 Immigration"
  },
  {
    "id": "IAB11-2",
    "name": "Legal Issues",
    "fullName": "IAB11-2 Legal Issues"
  },
  {
    "id": "IAB11-3",
    "name": "U.S. Government Resources",
    "fullName": "IAB11-3 U.S. Government Resources"
  },
  {
    "id": "IAB11-4",
    "name": "Politics",
    "fullName": "IAB11-4 Politics"
  },
  {
    "id": "IAB11-5",
    "name": "Commentary",
    "fullName": "IAB11-5 Commentary"
  },
  {
    "id": "IAB12-1",
    "name": "International News",
    "fullName": "IAB12-1 International News"
  },
  {
    "id": "IAB12-2",
    "name": "National News",
    "fullName": "IAB12-2 National News"
  },
  {
    "id": "IAB12-3",
    "name": "Local News",
    "fullName": "IAB12-3 Local News"
  },
  {
    "id": "IAB13-1",
    "name": "Beginning Investing",
    "fullName": "IAB13-1 Beginning Investing"
  },
  {
    "id": "IAB13-2",
    "name": "Credit/Debt & Loans",
    "fullName": "IAB13-2 Credit/Debt & Loans"
  },
  {
    "id": "IAB13-3",
    "name": "Financial News",
    "fullName": "IAB13-3 Financial News"
  },
  {
    "id": "IAB13-4",
    "name": "Financial Planning",
    "fullName": "IAB13-4 Financial Planning"
  },
  {
    "id": "IAB13-5",
    "name": "Hedge Fund",
    "fullName": "IAB13-5 Hedge Fund"
  },
  {
    "id": "IAB13-6",
    "name": "Insurance",
    "fullName": "IAB13-6 Insurance"
  },
  {
    "id": "IAB13-7",
    "name": "Investing",
    "fullName": "IAB13-7 Investing"
  },
  {
    "id": "IAB13-8",
    "name": "Mutual Funds",
    "fullName": "IAB13-8 Mutual Funds"
  },
  {
    "id": "IAB13-9",
    "name": "Options",
    "fullName": "IAB13-9 Options"
  },
  {
    "id": "IAB13-10",
    "name": "Retirement Planning",
    "fullName": "IAB13-10 Retirement Planning"
  },
  {
    "id": "IAB13-11",
    "name": "Stocks",
    "fullName": "IAB13-11 Stocks"
  },
  {
    "id": "IAB13-12",
    "name": "Tax Planning",
    "fullName": "IAB13-12 Tax Planning"
  },
  {
    "id": "IAB14-1",
    "name": "Dating",
    "fullName": "IAB14-1 Dating"
  },
  {
    "id": "IAB14-2",
    "name": "Divorce Support",
    "fullName": "IAB14-2 Divorce Support"
  },
  {
    "id": "IAB14-3",
    "name": "Gay Life",
    "fullName": "IAB14-3 Gay Life"
  },
  {
    "id": "IAB14-4",
    "name": "Marriage",
    "fullName": "IAB14-4 Marriage"
  },
  {
    "id": "IAB14-5",
    "name": "Senior Living",
    "fullName": "IAB14-5 Senior Living"
  },
  {
    "id": "IAB14-6",
    "name": "Teens",
    "fullName": "IAB14-6 Teens"
  },
  {
    "id": "IAB14-7",
    "name": "Weddings",
    "fullName": "IAB14-7 Weddings"
  },
  {
    "id": "IAB14-8",
    "name": "Ethnic Specific",
    "fullName": "IAB14-8 Ethnic Specific"
  },
  {
    "id": "IAB15-1",
    "name": "Astrology",
    "fullName": "IAB15-1 Astrology"
  },
  {
    "id": "IAB15-2",
    "name": "Biology",
    "fullName": "IAB15-2 Biology"
  },
  {
    "id": "IAB15-3",
    "name": "Chemistry",
    "fullName": "IAB15-3 Chemistry"
  },
  {
    "id": "IAB15-4",
    "name": "Geology",
    "fullName": "IAB15-4 Geology"
  },
  {
    "id": "IAB15-5",
    "name": "Paranormal Phenomena",
    "fullName": "IAB15-5 Paranormal Phenomena"
  },
  {
    "id": "IAB15-6",
    "name": "Physics",
    "fullName": "IAB15-6 Physics"
  },
  {
    "id": "IAB15-7",
    "name": "Space/Astronomy",
    "fullName": "IAB15-7 Space/Astronomy"
  },
  {
    "id": "IAB15-8",
    "name": "Ethnic Specific",
    "fullName": "IAB15-8 Ethnic Specific"
  },
  {
    "id": "IAB15-9",
    "name": "Botany",
    "fullName": "IAB15-9 Botany"
  },
  {
    "id": "IAB15-10",
    "name": "Weather",
    "fullName": "IAB15-10 Weather"
  },
  {
    "id": "IAB16-1",
    "name": "Aquariums",
    "fullName": "IAB16-1 Aquariums"
  },
  {
    "id": "IAB16-2",
    "name": "Birds",
    "fullName": "IAB16-2 Birds"
  },
  {
    "id": "IAB16-3",
    "name": "Cats",
    "fullName": "IAB16-3 Cats"
  },
  {
    "id": "IAB16-4",
    "name": "Dogs",
    "fullName": "IAB16-4 Dogs"
  },
  {
    "id": "IAB16-5",
    "name": "Large Animals",
    "fullName": "IAB16-5 Large Animals"
  },
  {
    "id": "IAB16-6",
    "name": "Reptiles",
    "fullName": "IAB16-6 Reptiles"
  },
  {
    "id": "IAB16-7",
    "name": "Veterinary Medicine",
    "fullName": "IAB16-7 Veterinary Medicine"
  },
  {
    "id": "IAB17-1",
    "name": "Auto Racing",
    "fullName": "IAB17-1 Auto Racing"
  },
  {
    "id": "IAB17-2",
    "name": "Baseball",
    "fullName": "IAB17-2 Baseball"
  },
  {
    "id": "IAB17-3",
    "name": "Bicycling",
    "fullName": "IAB17-3 Bicycling"
  },
  {
    "id": "IAB17-4",
    "name": "Bodybuilding",
    "fullName": "IAB17-4 Bodybuilding"
  },
  {
    "id": "IAB17-5",
    "name": "Boxing",
    "fullName": "IAB17-5 Boxing"
  },
  {
    "id": "IAB17-6",
    "name": "Canoeing/Kayaking",
    "fullName": "IAB17-6 Canoeing/Kayaking"
  },
  {
    "id": "IAB17-7",
    "name": "Cheerleading",
    "fullName": "IAB17-7 Cheerleading"
  },
  {
    "id": "IAB17-8",
    "name": "Climbing",
    "fullName": "IAB17-8 Climbing"
  },
  {
    "id": "IAB17-9",
    "name": "Cricket",
    "fullName": "IAB17-9 Cricket"
  },
  {
    "id": "IAB17-10",
    "name": "I Figure Skating",
    "fullName": "IIAB17-10 Figure Skating"
  },
  {
    "id": "IAB17-11",
    "name": "Fly Fishing",
    "fullName": "IAB17-11 Fly Fishing"
  },
  {
    "id": "IAB17-12",
    "name": "Football",
    "fullName": "IAB17-12 Football"
  },
  {
    "id": "IAB17-13",
    "name": "Freshwater Fishing",
    "fullName": "IAB17-13 Freshwater Fishing"
  },
  {
    "id": "IAB17-14",
    "name": "Game & Fish",
    "fullName": "IAB17-14 Game & Fish"
  },
  {
    "id": "IAB17-15",
    "name": "Golf",
    "fullName": "IAB17-15 Golf"
  },
  {
    "id": "IAB17-16",
    "name": "Horse Racing",
    "fullName": "IAB17-16 Horse Racing"
  },
  {
    "id": "IAB17-17",
    "name": "Horses",
    "fullName": "IAB17-17 Horses"
  },
  {
    "id": "IAB17-18",
    "name": "Hunting/Shooting",
    "fullName": "IAB17-18 Hunting/Shooting"
  },
  {
    "id": "IAB17-19",
    "name": "Inline Skating",
    "fullName": "IAB17-19 Inline Skating"
  },
  {
    "id": "IAB17-20",
    "name": "Martial Arts",
    "fullName": "IAB17-20 Martial Arts"
  },
  {
    "id": "IAB17-21",
    "name": "Mountain Biking",
    "fullName": "IAB17-21 Mountain Biking"
  },
  {
    "id": "IAB17-22",
    "name": "NASCAR Racing",
    "fullName": "IAB17-22 NASCAR Racing"
  },
  {
    "id": "IAB17-23",
    "name": "Olympics",
    "fullName": "IAB17-23 Olympics"
  },
  {
    "id": "IAB17-24",
    "name": "Paintball",
    "fullName": "IAB17-24 Paintball"
  },
  {
    "id": "IAB17-25",
    "name": "Power & Motorcycles",
    "fullName": "IAB17-25 Power & Motorcycles"
  },
  {
    "id": "IAB17-26",
    "name": "Pro Basketball",
    "fullName": "IAB17-26 Pro Basketball"
  },
  {
    "id": "IAB17-27",
    "name": "Pro Ice Hockey",
    "fullName": "IAB17-27 Pro Ice Hockey"
  },
  {
    "id": "IAB17-28",
    "name": "Rodeo",
    "fullName": "IAB17-28 Rodeo"
  },
  {
    "id": "IAB17-29",
    "name": "Rugby",
    "fullName": "IAB17-29 Rugby"
  },
  {
    "id": "IAB17-30",
    "name": "Running/Jogging",
    "fullName": "IAB17-30 Running/Jogging"
  },
  {
    "id": "IAB17-31",
    "name": "Sailing",
    "fullName": "IAB17-31 Sailing"
  },
  {
    "id": "IAB17-32",
    "name": "Saltwater Fishing",
    "fullName": "IAB17-32 Saltwater Fishing"
  },
  {
    "id": "IAB17-33",
    "name": "Scuba Diving",
    "fullName": "IAB17-33 Scuba Diving"
  },
  {
    "id": "IAB17-34",
    "name": "Skateboarding",
    "fullName": "IAB17-34 Skateboarding"
  },
  {
    "id": "IAB17-35",
    "name": "Skiing",
    "fullName": "IAB17-35 Skiing"
  },
  {
    "id": "IAB17-36",
    "name": "Snowboarding",
    "fullName": "IAB17-36 Snowboarding"
  },
  {
    "id": "IAB17-37",
    "name": "Surfing/Bodyboarding",
    "fullName": "IAB17-37 Surfing/Bodyboarding"
  },
  {
    "id": "IAB17-38",
    "name": "Swimming",
    "fullName": "IAB17-38 Swimming"
  },
  {
    "id": "IAB17-39",
    "name": "Table Tennis/Ping-Pong",
    "fullName": "IAB17-39 Table Tennis/Ping-Pong"
  },
  {
    "id": "IAB17-40",
    "name": "Tennis",
    "fullName": "IAB17-40 Tennis"
  },
  {
    "id": "IAB17-41",
    "name": "Volleyball",
    "fullName": "IAB17-41 Volleyball"
  },
  {
    "id": "IAB17-42",
    "name": "Walking",
    "fullName": "IAB17-42 Walking"
  },
  {
    "id": "IAB17-43",
    "name": "Waterski/Wakeboard",
    "fullName": "IAB17-43 Waterski/Wakeboard"
  },
  {
    "id": "IAB17-44",
    "name": "World Soccer",
    "fullName": "IAB17-44 World Soccer"
  },
  {
    "id": "IAB18-1",
    "name": "Beauty",
    "fullName": "IAB18-1 Beauty"
  },
  {
    "id": "IAB18-2",
    "name": "Body Art",
    "fullName": "IAB18-2 Body Art"
  },
  {
    "id": "IAB18-3",
    "name": "Fashion",
    "fullName": "IAB18-3 Fashion"
  },
  {
    "id": "IAB18-4",
    "name": "Jewelry",
    "fullName": "IAB18-4 Jewelry"
  },
  {
    "id": "IAB18-5",
    "name": "Clothing",
    "fullName": "IAB18-5 Clothing"
  },
  {
    "id": "IAB18-6",
    "name": "Accessories",
    "fullName": "IAB18-6 Accessories"
  },
  {
    "id": "IAB19-1",
    "name": "3-D Graphics",
    "fullName": "IAB19-1 3-D Graphics"
  },
  {
    "id": "IAB19-2",
    "name": "Animation",
    "fullName": "IAB19-2 Animation"
  },
  {
    "id": "IAB19-3",
    "name": "Antivirus Software",
    "fullName": "IAB19-3 Antivirus Software"
  },
  {
    "id": "IAB19-4",
    "name": "C/C++",
    "fullName": "IAB19-4 C/C++"
  },
  {
    "id": "IAB19-5",
    "name": "Cameras & Camcorders",
    "fullName": "IAB19-5 Cameras & Camcorders"
  },
  {
    "id": "IAB19-6",
    "name": "Cell Phones",
    "fullName": "IAB19-6 Cell Phones"
  },
  {
    "id": "IAB19-7",
    "name": "Computer Certification",
    "fullName": "IAB19-7 Computer Certification"
  },
  {
    "id": "IAB19-8",
    "name": "Computer Networking",
    "fullName": "IAB19-8 Computer Networking"
  },
  {
    "id": "IAB19-9",
    "name": "Computer Peripherals",
    "fullName": "IAB19-9 Computer Peripherals"
  },
  {
    "id": "IAB19-10",
    "name": "Computer Reviews",
    "fullName": "IAB19-10 Computer Reviews"
  },
  {
    "id": "IAB19-11",
    "name": "Data Centers",
    "fullName": "IAB19-11 Data Centers"
  },
  {
    "id": "IAB19-12",
    "name": "Databases",
    "fullName": "IAB19-12 Databases"
  },
  {
    "id": "IAB19-13",
    "name": "Desktop Publishing",
    "fullName": "IAB19-13 Desktop Publishing"
  },
  {
    "id": "IAB19-14",
    "name": "Desktop Video",
    "fullName": "IAB19-14 Desktop Video"
  },
  {
    "id": "IAB19-15",
    "name": "Email",
    "fullName": "IAB19-15 Email"
  },
  {
    "id": "IAB19-16",
    "name": "Graphics Software",
    "fullName": "IAB19-16 Graphics Software"
  },
  {
    "id": "IAB19-17",
    "name": "Home Video/DVD",
    "fullName": "IAB19-17 Home Video/DVD"
  },
  {
    "id": "IAB19-18",
    "name": "Internet Technology",
    "fullName": "IAB19-18 Internet Technology"
  },
  {
    "id": "IAB19-19",
    "name": "Java",
    "fullName": "Java"
  },
  {
    "id": "IAB19-20",
    "name": "JavaScript",
    "fullName": "IAB19-20 JavaScript"
  },
  {
    "id": "IAB19-21",
    "name": "Mac Support",
    "fullName": "IAB19-21 Mac Support"
  },
  {
    "id": "IAB19-22",
    "name": "MP3/MIDI",
    "fullName": "IAB19-22 MP3/MIDI"
  },
  {
    "id": "IAB19-23",
    "name": "Net Conferencing",
    "fullName": "IAB19-23 Net Conferencing"
  },
  {
    "id": "IAB19-24",
    "name": "Net for Beginners",
    "fullName": "IAB19-24 Net for Beginners"
  },
  {
    "id": "IAB19-25",
    "name": "Network Security",
    "fullName": "IAB19-25 Network Security"
  },
  {
    "id": "IAB19-26",
    "name": "Palmtops/PDAs",
    "fullName": "IAB19-26 Palmtops/PDAs"
  },
  {
    "id": "IAB19-27",
    "name": "PC Support",
    "fullName": "IAB19-27 PC Support"
  },
  {
    "id": "IAB19-28",
    "name": "Portable",
    "fullName": "IAB19-28 Portable"
  },
  {
    "id": "IAB19-29",
    "name": "Entertainment",
    "fullName": "IAB19-29 Entertainment"
  },
  {
    "id": "IAB19-30",
    "name": "Shareware/Freeware",
    "fullName": "IAB19-30 Shareware/Freeware"
  },
  {
    "id": "IAB19-31",
    "name": "Unix",
    "fullName": "IAB19-31 Unix"
  },
  {
    "id": "IAB19-32",
    "name": "Visual Basic",
    "fullName": "IAB19-32 Visual Basic"
  },
  {
    "id": "IAB19-33",
    "name": "Web Clip Art",
    "fullName": "IAB19-33 Web Clip Art"
  },
  {
    "id": "IAB19-34",
    "name": "Web Design/HTML",
    "fullName": "IAB19-34 Web Design/HTML"
  },
  {
    "id": "IAB19-35",
    "name": "Web Search",
    "fullName": "IAB19-35 Web Search"
  },
  {
    "id": "IAB19-36",
    "name": "Windows",
    "fullName": "IAB19-36 Windows"
  },
  {
    "id": "IAB20-1",
    "name": "Adventure Travel",
    "fullName": "IAB20-1 Adventure Travel"
  },
  {
    "id": "IAB20-2",
    "name": "Africa",
    "fullName": "IAB20-2 Africa"
  },
  {
    "id": "IAB20-3",
    "name": "Air Travel",
    "fullName": "IAB20-3 Air Travel"
  },
  {
    "id": "IAB20-4",
    "name": "Australia & New Zealand",
    "fullName": "IAB20-4 Australia & New Zealand"
  },
  {
    "id": "IAB20-5",
    "name": "Bed & Breakfasts",
    "fullName": "IAB20-5 Bed & Breakfasts"
  },
  {
    "id": "IAB20-6",
    "name": "Budget Travel",
    "fullName": "IAB20-6 Budget Travel"
  },
  {
    "id": "IAB20-7",
    "name": "Business Travel",
    "fullName": "IAB20-7 Business Travel"
  },
  {
    "id": "IAB20-8",
    "name": "By US Locale",
    "fullName": "IAB20-8 By US Locale"
  },
  {
    "id": "IAB20-9",
    "name": "Camping",
    "fullName": "IAB20-9 Camping"
  },
  {
    "id": "IAB20-10",
    "name": "Canada",
    "fullName": "IAB20-10 Canada"
  },
  {
    "id": "IAB20-11",
    "name": "Caribbean",
    "fullName": "IAB20-11 Caribbean"
  },
  {
    "id": "IAB20-12",
    "name": "Cruises",
    "fullName": "IAB20-12 Cruises"
  },
  {
    "id": "IAB20-13",
    "name": "Eastern Europe",
    "fullName": "IAB20-13 Eastern Europe"
  },
  {
    "id": "IAB20-14",
    "name": "Europe",
    "fullName": "IAB20-14 Europe"
  },
  {
    "id": "IAB20-15",
    "name": "France",
    "fullName": "IAB20-15 France"
  },
  {
    "id": "IAB20-16",
    "name": "Greece",
    "fullName": "IAB20-16 Greece"
  },
  {
    "id": "IAB20-17",
    "name": "Honeymoons/Getaways",
    "fullName": "IAB20-17 Honeymoons/Getaways"
  },
  {
    "id": "IAB20-18",
    "name": "Hotels",
    "fullName": "IAB20-18 Hotels"
  },
  {
    "id": "IAB20-19",
    "name": "Italy",
    "fullName": "IAB20-19 Italy"
  },
  {
    "id": "IAB20-20",
    "name": "Japan",
    "fullName": "IAB20-20 Japan"
  },
  {
    "id": "IAB20-21",
    "name": "Mexico & Central America",
    "fullName": "IAB20-21 Mexico & Central America"
  },
  {
    "id": "IAB20-22",
    "name": "National Parks",
    "fullName": "IAB20-22 National Parks"
  },
  {
    "id": "IAB20-23",
    "name": "South America",
    "fullName": "IAB20-23 South America"
  },
  {
    "id": "IAB20-24",
    "name": "Spas",
    "fullName": "IAB20-24 Spas"
  },
  {
    "id": "IAB20-25",
    "name": "Theme Parks",
    "fullName": "IAB20-25 Theme Parks"
  },
  {
    "id": "IAB20-26",
    "name": "Traveling with Kids",
    "fullName": "IAB20-26 Traveling with Kids"
  },
  {
    "id": "IAB20-27",
    "name": "United Kingdom",
    "fullName": "IAB20-27 United Kingdom"
  },
  {
    "id": "IAB21-1",
    "name": "Apartments",
    "fullName": "IAB21-1 Apartments"
  },
  {
    "id": "IAB21-2",
    "name": "Architects",
    "fullName": "IAB21-2 Architects"
  },
  {
    "id": "IAB21-3",
    "name": "Buying/Selling Homes",
    "fullName": "IAB21-3 Buying/Selling Homes"
  },
  {
    "id": "IAB22-1",
    "name": "Contests & Freebies",
    "fullName": "IAB22-1 Contests & Freebies"
  },
  {
    "id": "IAB22-2",
    "name": "Couponing",
    "fullName": "IAB22-2 Couponing"
  },
  {
    "id": "IAB22-3",
    "name": "Comparison",
    "fullName": "IAB22-3 Comparison"
  },
  {
    "id": "IAB22-4",
    "name": "Engines",
    "fullName": "IAB22-4 Engines"
  },
  {
    "id": "IAB23-1",
    "name": "Alternative Religions",
    "fullName": "IAB23-1 Alternative Religions"
  },
  {
    "id": "IAB23-2",
    "name": "Atheism/Agnosticism",
    "fullName": "IAB23-2 Atheism/Agnosticism"
  },
  {
    "id": "IAB23-3",
    "name": "Buddhism",
    "fullName": "IAB23-3 Buddhism"
  },
  {
    "id": "IAB23-4",
    "name": "Catholicism",
    "fullName": "IAB23-4 Catholicism"
  },
  {
    "id": "IAB23-5",
    "name": "Christianity",
    "fullName": "IAB23-5 Christianity"
  },
  {
    "id": "IAB23-6",
    "name": "Hinduism",
    "fullName": "IAB23-6 Hinduism"
  },
  {
    "id": "IAB23-7",
    "name": "Islam",
    "fullName": "IAB23-7 Islam"
  },
  {
    "id": "IAB23-8",
    "name": "Judaism",
    "fullName": "IAB23-8 Judaism"
  },
  {
    "id": "IAB23-9",
    "name": "Latter-Day Saints",
    "fullName": "IAB23-9 Latter-Day Saints"
  },
  {
    "id": "IAB23-10",
    "name": "Pagan/Wiccan",
    "fullName": "IAB23-10 Pagan/Wiccan"
  },
  {
    "id": "IAB25-1",
    "name": "Unmoderated UGC",
    "fullName": "IAB25-1 Unmoderated UGC"
  },
  {
    "id": "IAB25-2",
    "name": "Extreme Graphic/Explicit Violence",
    "fullName": "IAB25-2 Extreme Graphic/Explicit Violence"
  },
  {
    "id": "IAB25-3",
    "name": "Pornography",
    "fullName": "IAB25-3 Pornography"
  },
  {
    "id": "IAB25-4",
    "name": "Profane Content",
    "fullName": "IAB25-4 Profane Content"
  },
  {
    "id": "IAB25-6",
    "name": "Under Construction",
    "fullName": "IAB25-6 Under Construction"
  },
  {
    "id": "IAB25-7",
    "name": "Incentivized",
    "fullName": "IAB25-7 Incentivized"
  },
  {
    "id": "IAB26-1",
    "name": "Illegal Content",
    "fullName": "IAB26-1 Illegal Content"
  },
  {
    "id": "IAB26-2",
    "name": "Warez",
    "fullName": "IAB26-2 Warez"
  },
  {
    "id": "IAB26-3",
    "name": "Spyware/Malware",
    "fullName": "IAB26-3 Spyware/Malware"
  },
  {
    "id": "IAB26-4",
    "name": "Copyright Infringement",
    "fullName": "IAB26-4 Copyright Infringement"
  }
];

export const contextualTargetingTypes = [
  {value: 'web', label: 'Web'},
  {value: 'inApp', label: 'In App'},
];

export const verticalOptions = [
  {value: 'None', text: 'None', color: null},
  {value: 'Arts & Entertainment', text: 'Arts & Entertainment', color: 'rgb(155, 89, 182)'},
  {value: 'Automotive', text: 'Automotive', color: 'rgb(52, 73, 94)'},
  {value: 'Betting', text: 'Betting', color: 'rgb(22, 160, 133)'},
  {value: 'Business', text: 'Business', color: 'rgb(41, 128, 185)'},
  {value: 'Career', text: 'Career', color: 'rgb(93, 109, 126)'},
  {value: 'Casino', text: 'Casino', color: 'rgb(192, 57, 43)'},
  {value: 'Crypto', text: 'Crypto', color: 'rgb(243, 156, 18)'},
  {value: 'Dating', text: 'Dating', color: 'rgb(231, 76, 60)'},
  {value: 'E-commerce', text: 'E-commerce', color: 'rgb(39, 174, 96)'},
  {value: 'Education', text: 'Education', color: 'rgb(52, 152, 219)'},
  {value: 'Family & Parenting', text: 'Family & Parenting', color: 'rgb(230, 126, 34)'},
  {value: 'Financial Services', text: 'Financial Services', color: 'rgb(31, 97, 141)'},
  {value: 'Food & Drink', text: 'Food & Drink', color: 'rgb(211, 84, 0)'},
  {value: 'Games', text: 'Games', color: 'rgb(142, 68, 173)'},
  {value: 'Health & Fitness', text: 'Health & Fitness', color: 'rgb(40, 180, 99)'},
  {value: 'Hobbies & Interests', text: 'Hobbies & Interests', color: 'rgb(241, 196, 15)'},
  {value: 'Home & Garden', text: 'Home & Garden', color: 'rgb(39, 174, 96)'},
  {value: 'Insurance', text: 'Insurance', color: 'rgb(93, 173, 226)'},
  {value: 'Law, Government & Politics', text: 'Law, Government & Politics', color: 'rgb(100, 100, 100)'},
  {value: 'News', text: 'News', color: 'rgb(52, 73, 94)'},
  {value: 'Nutrition & Supplements', text: 'Nutrition & Supplements', color: 'rgb(88, 214, 141)'},
  {value: 'Personal Finance', text: 'Personal Finance', color: 'rgb(46, 134, 193)'},
  {value: 'Pets', text: 'Pets', color: 'rgb(243, 156, 18)'},
  {value: 'Real Estate', text: 'Real Estate', color: 'rgb(161, 136, 127)'},
  {value: 'Science', text: 'Science', color: 'rgb(72, 201, 176)'},
  {value: 'Sports', text: 'Sports', color: 'rgb(231, 76, 60)'},
  {value: 'Style & Fashion', text: 'Style & Fashion', color: 'rgb(236, 112, 99)'},
  {value: 'Technology & Computing', text: 'Technology & Computing', color: 'rgb(84, 153, 199)'},
  {value: 'Travel', text: 'Travel', color: 'rgb(26, 188, 156)'},
  {value: 'Utilities', text: 'Utilities', color: 'rgb(149, 165, 166)'},
];
